import { useQuery } from "@tanstack/react-query";
import { toastServerError } from "helpers";
import {
  ApiError,
  ApiServiceError,
  GetListRequestParams,
  GetListResponse
} from "libs/api";
import { QueryOptions } from "libs/reactQuery";

import { ContentVideoListItem } from "../../content.types";
import { requestGetVideos } from "./requestGetVideos.request";

const useGetVideosList = (
  requestParams: GetListRequestParams,
  options?: QueryOptions<
    GetListResponse<ContentVideoListItem>,
    ApiServiceError<ApiError>
  >
) => {
  const { data, ...rest } = useQuery({
    queryKey: ["content-videos-admin", "all", requestParams],
    queryFn: async () => await requestGetVideos(requestParams),
    onError: toastServerError,
    ...options
  });

  return { videosList: data?.data, meta: data?.meta, ...rest };
};

export default useGetVideosList;
